export const InsightType = { REP: "REP", Infrastructure: "Infrastructure", Environment: "Environment", Economy: "Economy", Impact: "Impact" };
